<script>
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import {VMoney} from 'v-money'
  export default{
    name: 'i-lance-manual',
    data () {
      return {
        money: REAL_BRL,
        valorFormatado: ''
      }
    },
    computed: {
      valor () {
        return Number((this.valorFormatado.replace(/[^0-9,]/g, '')).replace(',', '.'))
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      focusIncrementoManual () {
        this.$refs.input.focus()
      },
      incremento () {
        if (this.valor === 0) {
          return
        }
        this.$emit('lanceManual', this.valor)
        this.reset()
      },
      reset () {
        this.valorFormatado = ''
      }
    },
    directives: {money: VMoney},
    components: {}
  }
</script>

<template>
  <div class="lance-input-container">
    <label>Lance manual:</label>
    <div class="pos-rlt"><input ref="input" v-shortkey="['f2']" @shortkey="focusIncrementoManual"
                                v-model="valorFormatado" class="lance-input no-shortkey" placeholder="R$ 0,00"
                                @keyup.enter="incremento"
                                v-money="money"/><i class="shoutcut">F2</i></div>
    <u-button class="lance-btn" @click="incremento">OK</u-button>
  </div>
</template>



// WEBPACK FOOTER //
// InputLanceManual.vue?47528221